import {
  parse,
  stringify
} from "./chunk-ZM24AXRE.mjs";

// src/middleware.ts
import { mergeWith, isEqual, cloneDeep } from "lodash-es";
var compact = (newState, initialState) => {
  const output = {};
  Object.keys(newState).forEach((key) => {
    if (newState[key] !== null && newState[key] !== void 0 && typeof newState[key] !== "function" && !isEqual(newState[key], initialState[key])) {
      if (typeof newState[key] === "object" && !Array.isArray(newState[key])) {
        const value = compact(newState[key], initialState[key]);
        if (value && Object.keys(value).length > 0) {
          output[key] = value;
        }
      } else {
        output[key] = newState[key];
      }
    }
  });
  return output;
};
var translateSelectionToState = (selection, state) => {
  if (typeof state !== "object" || !state) {
    return {};
  }
  return Object.keys(selection).reduce((acc, key) => {
    if (!(key in state)) {
      return acc;
    }
    const value = selection[key];
    if (typeof value === "boolean") {
      if (value) {
        acc[key] = state[key];
      }
    } else {
      acc[key] = translateSelectionToState(value, state[key]);
    }
    return acc;
  }, {});
};
var escapeStringRegexp = (string) => {
  if (typeof string !== "string") {
    throw new TypeError("Expected a string");
  }
  return string.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
};
var queryStringImpl = (fn, options) => (set, get, api) => {
  const defaultedOptions = {
    key: "$",
    ...options
  };
  const escapedKey = escapeStringRegexp(defaultedOptions.key);
  const stateMatcher = new RegExp(`${escapedKey}=(.*);;|${escapedKey}=(.*)$`);
  const splitMatcher = new RegExp(`${escapedKey}=.*;;|${escapedKey}=.*$`);
  const parseQueryString = (querystring2) => {
    var _a;
    const match = querystring2.match(stateMatcher);
    if (match) {
      return parse((_a = match[1]) != null ? _a : match[2]);
    }
    return null;
  };
  const url = defaultedOptions.url;
  const getSelectedState = (state, pathname) => {
    if (defaultedOptions.select) {
      const selection = defaultedOptions.select(pathname);
      const selectedState = translateSelectionToState(selection, state);
      return selectedState;
    }
    return state != null ? state : {};
  };
  const initialize = (url2, initialState) => {
    try {
      const queryString = url2.search.substring(1);
      const pathname = url2.pathname;
      if (!queryString) {
        return initialState;
      }
      const parsed = parseQueryString(queryString);
      if (!parsed) {
        return initialState;
      }
      const merged = mergeWith(
        cloneDeep(initialState),
        getSelectedState(parsed, pathname)
      );
      set(merged, true);
      return merged;
    } catch (error) {
      console.error(error);
      return initialState;
    }
  };
  if (typeof window !== "undefined") {
    const initialState = cloneDeep(
      fn(
        (...args) => {
          set(...args);
          setQuery();
        },
        get,
        api
      )
    );
    const setQuery = () => {
      const selectedState = getSelectedState(get(), location.pathname);
      const currentQueryString = location.search;
      const currentParsed = parseQueryString(currentQueryString);
      const newMerged = {
        ...currentParsed,
        ...selectedState
      };
      const splitIgnored = currentQueryString.split(splitMatcher);
      let ignored = "";
      for (let str of splitIgnored) {
        if (!str || str === "?" || str === "&") {
          continue;
        }
        if (str.startsWith("&") || str.startsWith("?")) {
          str = str.substring(1);
        }
        if (str.endsWith("&")) {
          str = str.substring(0, str.length - 1);
        }
        ignored += (ignored ? "&" : "?") + str;
      }
      const newCompacted = compact(newMerged, initialState);
      let newQueryString = "";
      if (Object.keys(newCompacted).length) {
        const stringified = stringify(newCompacted);
        const newQueryState = `${defaultedOptions.key}=${stringified};;`;
        if (currentParsed) {
          newQueryString = currentQueryString.replace(
            splitMatcher,
            newQueryState
          );
        } else if (ignored) {
          newQueryString = ignored + "&" + newQueryState;
        } else {
          newQueryString = "?" + newQueryState;
        }
      } else {
        newQueryString = ignored;
      }
      const currentUrl = location.pathname + location.search;
      const newUrl = location.pathname + newQueryString;
      if (newUrl !== currentUrl) {
        history.replaceState(history.state, "", newUrl);
      }
    };
    if (!api.__ZUSTAND_QUERYSTRING_INIT__) {
      api.__ZUSTAND_QUERYSTRING_INIT__ = true;
      let previousPathname = "";
      const cb = () => {
        if (location.pathname !== previousPathname) {
          previousPathname = location.pathname;
          setQuery();
        }
        requestAnimationFrame(cb);
      };
      requestAnimationFrame(cb);
    }
    const originalSetState = api.setState;
    api.setState = (...args) => {
      originalSetState(...args);
      setQuery();
    };
    return initialize(new URL(location.href), initialState);
  } else if (url) {
    return initialize(
      new URL(decodeURIComponent(url), "http://localhost"),
      fn(set, get, api)
    );
  }
  return fn(set, get, api);
};
var querystring = queryStringImpl;

export {
  querystring
};
